import 'iron/csrf';

import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';
import {setReferrerSuperpropsAndBaseTracking, setUserBasedTrackingProps} from 'common/report/report-tracker';

import '../common/stylesheets/defaults/color-vars.styl';

document.addEventListener('DOMContentLoaded', () => {
  const user = userCookieUtils.getUserIdentityFromCookie();
  if (user) {
    setReferrerSuperpropsAndBaseTracking({userId: user.id});
    const [lastName, firstName] = user.name?.split(', ');
    setUserBasedTrackingProps({
      firstName,
      lastName,
      email: user.email,
    });
  }
});
